import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

type InquiryAssignStatus = {
  id: number
  name: string
  hint: string | null
  sort_weight: number
  enabled: boolean
}

type GetInquiryAssignStatusesResponse = {
  inquiry_assign_statuses: InquiryAssignStatus[]
}

export function useInquiryAssignStatuses() {
  return useQuery({
    queryKey: queryKeys.inquiryAssignStatuses,
    queryFn: () =>
      apiFetch<GetInquiryAssignStatusesResponse>('/api/inquiry-assign-statuses', {
        method: 'GET',
      }),
    staleTime: 60 * 60 * 1000,
  })
}
